export const ADDRESS_FINDER_URI = (KEY, SECRET, QUERY) =>
  `https://api.addressfinder.io/api/nz/address?key=${KEY}&secret=${SECRET}&q=${encodeURI(
    QUERY
  )}&format=json&strict=2`;

export const MAP_BOX_STATIC_IMG = (LAT, LONG) => `
  https://api.mapbox.com/styles/v1/mapbox/streets-v9/static/pin-l-marker+285A98(${LONG},${LAT})/${LONG},${LAT},17,0/600x300@2x?access_token=${process.env.MAP_BOX_KEY}
`;
